import { store } from "../store";
import { call, takeLatest } from "redux-saga/effects";
import ENV from "../config/env";
import {
  STAFF_LISTING_REQUEST,
  ADD_STAFF_REQUEST,
  UPDATE_USER_ACTIVE_FLAG_REQUEST,
  UPDATE_USER_ROLES_REQUEST,
  GET_STAFF_USER_DETAILS_REQUEST,
} from "./staffManagement.type";
import axiosInstance from "../../api/axiosInstance";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}

function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function* staffListingSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/listing/Users`,
      payload,
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* addStaffSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/add/User`,
      payload,
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* updateUserActiveFlagSaga(action) {
  const { payload, callback } = action;
  const { id, active, deactivateReason } = payload;
  let url = `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/update/UserActiveFlag?id=${id}&active=${active}`;
  if (deactivateReason) {
    url += `&deactivateReason=${encodeURIComponent(deactivateReason)}`;
  }
  try {
    const { data } = yield call(
      axiosInstance.post,
      url,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* updateUserRolesSaga(action) {
  const { payload, callback } = action;
  const { id, roles, module } = payload;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/update/UserRoles?id=${id}&roles=${roles}&module=${module}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getStaffUserDetailsSaga(action) {
  const { payload, callback } = action;
  const { id } = payload;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/get/User/Details/ById/ForStaffManagement?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* staffManagementWatcherSaga() {
  yield takeLatest(STAFF_LISTING_REQUEST, staffListingSaga);
  yield takeLatest(ADD_STAFF_REQUEST, addStaffSaga);
  yield takeLatest(UPDATE_USER_ACTIVE_FLAG_REQUEST, updateUserActiveFlagSaga);
  yield takeLatest(UPDATE_USER_ROLES_REQUEST, updateUserRolesSaga);
  yield takeLatest(GET_STAFF_USER_DETAILS_REQUEST, getStaffUserDetailsSaga);
}
